import * as RadixSwitch from '@radix-ui/react-switch';
import { useId, type ComponentPropsWithoutRef, type ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './Switch.module.scss';

export interface SwitchProps extends ComponentPropsWithoutRef<typeof RadixSwitch.Root> {
  /** Подпись рядом с переключателем. Без неё обязателен `aria-label`. */
  children?: ReactNode;
}

/**
 * Переключатель «включено / выключено» поверх Radix.
 *
 * Отличается от флажка смыслом: переключатель — состояние, которое действует
 * сразу и само по себе («Показывать в меню»), флажок — отметка в перечне.
 */
export function Switch({ className, children, id, ...rest }: SwitchProps) {
  const generatedId = useId();
  const controlId = id ?? generatedId;

  const control = (
    <RadixSwitch.Root id={controlId} className={styles['switch']} {...rest}>
      <RadixSwitch.Thumb className={styles['switch__thumb']} />
    </RadixSwitch.Root>
  );

  if (children === undefined) {
    return control;
  }

  return (
    <div className={cx(styles['field'], className)}>
      {control}
      <label className={styles['field__label']} htmlFor={controlId}>
        {children}
      </label>
    </div>
  );
}
